export default [
  {
    path: '/groups',
    meta: {
      auth: true,
    },
    component: () => import('~/common/layouts/default.vue'),
    children: [
      {
        path: '',
        name: 'groups',
        component: () => import('~/groups/pages/Index.vue'),
      },
    ],
  },
];
